export const GET_CITIES = Symbol('GET_CITIES');
export const GET_CITIES_REQUEST = Symbol('GET_CITIES_REQUEST');
export const GET_CITIES_SUCCESS = Symbol('GET_CITIES_SUCCESS');
export const GET_CITIES_ERROR = Symbol('GET_CITIES_ERROR');

